import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PermissionControlService {

  private serviceConfig = {
    msgTimeline: {
      name: '消息交互时光轴',
      quickField: 'timeline',
      hide: false,
      menus: [{
        text: '消息交互时光轴'
      }]
    },
    statReport: {
      name: '运营周月报',
      quickField: 'report',
      hide: false,
      menus: [{
        text: '运营周月报'
      }]
    },
    shortUrl: {
      name: '智能短链跟踪',
      quickField: 'shorturl',
      hide: false,
      menus: [{
        text: '短链中心'
      }]
    },
    patch: {
      name: '智能营销贴片',
      quickField: 'patch',
      hide: false,
      menus: [{
        text: '贴片管理'
      }, {
        text: '贴片审核'
      }]
    }
  }

  constructor() { }

  /* 针对配置上的菜单权限进行隐藏控制 */
  public menuControl(menus) {
    const hiddenMenuTexts = [];
    this.forEachConfig(serviceItem => {
      if(serviceItem.menus && serviceItem.menus.length) {
          serviceItem.menus.forEach(menu => {
            if(serviceItem.hide) {
              hiddenMenuTexts.push(menu.text);
            }
          })
        }
    });
    if(hiddenMenuTexts.length) {
      this.iteartorMenuTree(hiddenMenuTexts, menus);
    }
    return menus;
  }

  /* 通过快捷字段获取显隐配置 */
  public getLimitByField(quickField: string): boolean {
    let hide = false;
    this.forEachConfig(serviceItem => {
      if(quickField === serviceItem.quickField) {
        hide = serviceItem.hide;
      }
    });
    return hide;
  }

  private forEachConfig(cb: Function) {
    for (const key in this.serviceConfig) {
      if (Object.prototype.hasOwnProperty.call(this.serviceConfig, key)) {
        cb(this.serviceConfig[key])
      }
    }
  }

  private iteartorMenuTree(_hiddenMenuTexts, _menus) {
    _menus.forEach(menu => {
      menu.hide = _hiddenMenuTexts.indexOf(menu.text) !== -1;
      if(menu.children && menu.children.length) {
        this.iteartorMenuTree(_hiddenMenuTexts, menu.children);
      }
    })
  }

}
